import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useSelf } from 'components/providers/SelfProvider'

// Redirects signed-in users to their home page (e.g. /users/417A3F46).
// Returns true while the redirect is pending so callers can render nothing.
export const useRedirectSignedIn = () => {
	const router = useRouter()
	const { isSignedIn, user } = useSelf()

	const shouldRedirect = isSignedIn && !!user?.baseSlug

	useEffect(() => {
		if (shouldRedirect) {
			router.replace(user.baseSlug)
		}
	}, [shouldRedirect, router, user?.baseSlug])

	return shouldRedirect
}
